<template>
  <TextInput v-bind="{ ...$attrs, ...props }" :type="inputType">
    <template #append-inner>
      <IconButton
        :icon-name="
          inputType === InputType.PASSWORD ? IconName.EYE : IconName.EYE_SLASH
        "
        :label="
          inputType === InputType.PASSWORD ? 'Show password' : 'Hide password'
        "
        :size="ButtonSize.XS"
        :variant="ButtonVariant.TEXT"
        :color="ButtonColor.SECONDARY"
        @click="changeInputType"
      />
    </template>
  </TextInput>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { TextInput } from '@/components/inputs/text-input';
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconName,
} from '@exfluential/ui';
import { RuleExpression } from 'vee-validate';

type Props = {
  id?: string;
  modelValue: string;
  placeholder?: string;

  rules?: RuleExpression<unknown>;
  hideDetails?: boolean | 'auto';

  label?: string;
  disabled?: boolean;
};
const props = defineProps<Props>();

enum InputType {
  PASSWORD = 'password',
  TEXT = 'text',
}

const inputType = ref<InputType>(InputType.PASSWORD);

const changeInputType = () => {
  inputType.value =
    inputType.value === InputType.PASSWORD
      ? InputType.TEXT
      : InputType.PASSWORD;
};
</script>
